module.exports = __webpack_public_path__ + "img/104.860e961f.jpg";